module.exports = __webpack_public_path__ + "static/img/activity_sdy_03-4.24ec19f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_03-4.jpg
// module id = 9cLU
// module chunks = 0